module.exports = __webpack_public_path__ + "img/zl1.a12fae8c.png";